import { render, staticRenderFns } from "./MarketRates2.vue?vue&type=template&id=3641323e&scoped=true"
import script from "./MarketRates2.vue?vue&type=script&lang=js"
export * from "./MarketRates2.vue?vue&type=script&lang=js"
import style0 from "./MarketRates2.vue?vue&type=style&index=0&id=3641323e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641323e",
  null
  
)

export default component.exports